export const TAB_MODAL_WIDGET = 'modal-widget';
export const TAB_INLINE_WIDGET = 'inline-widget';
export const TAB_BRIDGE_WIDGET = 'bridge-widget';
export const TAB_UPDATE_PI_WIDGET = 'update-pi-widget';
export const TAB_BUTTON_WIDGET = 'button-widget';



// WEBPACK FOOTER //
// ./src/tabs/TabsConstants.js